module.exports = __webpack_public_path__ + "static/media/four.8550e6e1.ogg";